import React from 'react';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';

function AccessDenied({ history }) {
  return (
    <div data-testid="access-denied" style={{ textAlign: 'center', marginTop: '10%', padding: '20px' }}>
      <span className="material-icons" style={{ fontSize: 64, color: '#e53935' }}>lock</span>
      <h1 style={{ color: '#e53935', marginTop: 16 }}>Access Denied</h1>
      <p style={{ color: '#555', fontSize: 16, marginBottom: 24 }}>
        You do not have permission to view this page.
        Please contact your administrator if you believe this is an error.
      </p>
      <Button variant="contained" className='btn btn-action' onClick={() => history.goBack()}>
        Go Back
      </Button>
    </div>
  );
}

export default withRouter(AccessDenied);
